import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import DipendenteDashboard from './components/DipendenteDashboard';
import './App.css';
import { Toaster } from 'react-hot-toast';


// Componente per proteggere le rotte
function PrivateRoute({ children, allowedRole }) {
  const { currentUser, userRole, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  if (allowedRole && userRole !== allowedRole) {
    if (userRole === 'admin') return <Navigate to="/admin" replace />;
    if (userRole === 'dipendente') return <Navigate to="/dipendente" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
}

// Banner aggiornamento PWA
function UpdateBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const currentVersion = process.env.REACT_APP_VERSION;
    if (!currentVersion) return;

    // Controlla ogni 2 minuti
    const check = async () => {
      try {
        const res = await fetch('/version.json?t=' + Date.now());
        const data = await res.json();
        if (data.version && data.version !== currentVersion) {
          setShowBanner(true);
        }
      } catch (e) {
        // nessuna connessione, ignora
      }
    };

    check(); // controllo immediato all'avvio
    const interval = setInterval(check, 2 * 60 * 1000); // ogni 2 minuti
    return () => clearInterval(interval);
  }, []);

  const handleUpdate = () => {
    window.location.reload(true);
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#1a1a2e',
      color: '#fff',
      padding: '14px 20px',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '14px',
      zIndex: 9999,
      fontSize: '14px',
      maxWidth: '90vw',
      whiteSpace: 'nowrap',
    }}>
      <span>🆕 Nuova versione disponibile</span>
      <button
        onClick={handleUpdate}
        style={{
          background: '#667eea',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          padding: '8px 16px',
          cursor: 'pointer',
          fontWeight: '600',
          fontSize: '13px',
          whiteSpace: 'nowrap',
        }}
      >
        Aggiorna ora
      </button>
      <button
        onClick={() => setShowBanner(false)}
        style={{
          background: 'transparent',
          color: '#aaa',
          border: 'none',
          cursor: 'pointer',
          fontSize: '18px',
          lineHeight: 1,
          padding: '0 4px',
        }}
      >
        ✕
      </button>
    </div>
  );
}

function App() {
  return (
    <Router>
     <Toaster 
        position="bottom-center" 
        // 1. Sposta il toast più in alto rispetto al fondo dello schermo
        containerStyle={{
          bottom: 100, // Distanza di 50px dal bottom (puoi aumentarla o diminuirla)
        }}
        toastOptions={{ 
          duration: 4000,
          // 2. Definisce lo stile predefinito (sfondo, colore, grandezza) per tutti i toast
          style: {
            background: '#1f2937', // Sfondo scuro (es. grigio scuro)
            color: '#ffffff',     // Testo bianco
            width: '400px',        // Larghezza fissa del toast
            maxWidth: '90%',       // Evita che esca dallo schermo su dispositivi mobili
            fontSize: '15px',      // Grandezza del testo
            padding: '16px',       // Spazio interno
            borderRadius: '8px',   // Angoli arrotondati
          }
        }} 
      />
      <AuthProvider>
        <UpdateBanner />
        <Routes>
          <Route path="/" element={<Login />} />
          
          <Route 
            path="/admin" 
            element={
              <PrivateRoute allowedRole="admin">
                <AdminDashboard />
              </PrivateRoute>
            } 
          />
          
          <Route 
            path="/dipendente" 
            element={
              <PrivateRoute allowedRole="dipendente">
                <DipendenteDashboard />
              </PrivateRoute>
            } 
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;